export default __webpack_public_path__ + "img/844b66ad42b004b1e3344bb3a6014781.png";